import React from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { BrandConfigContextProvider } from "banco/contexts/BrandConfigContext";
import { queryClient } from "banco/hooks/queryClient/queryClient";

/**
 * Wraps banco-website pages in global shared contexts and providers.
 */
export const PageContainer = ({ children }: {children: React.JSX.Element}): React.JSX.Element => {
  return (
    <QueryClientProvider client={ queryClient }>
      <BrandConfigContextProvider brand={ window.static_data?.brand }>
        { children }
      </BrandConfigContextProvider>
    </QueryClientProvider>
  );
};
